import { useMemo, useState } from "react";

export type Location =
	| "home"
	| "template-manager"
	| "template-manager-edit-form-template"
	| "template-manager-edit-fields-main"
	| "template-manager-edit-field"
	| "template-manager-table-cells"
	| "sync-menu"
	| "project-list"
	| "form-group"
	| "table"
	| "table-card-view"
	| "profile"
	| "release-notes";

function useDrawer() {
	const [drawer, setDrawerLocation] = useState<Location | "">("");

	function setupDrawer(location: Location | "") {
		setDrawerLocation(location);
	}

	const results = useMemo(
		() => ({
			drawer,
			setupDrawer,
		}),
		[drawer, setupDrawer],
	);

	return results;
}

export default useDrawer;
